import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import Declarative from "../../validations/es6/plugins/Declarative";

import { getValidationMessage } from "../../utils/i18nHelper";

import subUsersValidationEN from "../../locales/en/subUsersValidation";
import subUsersValidationDE from "../../locales/de/subUsersValidation";
import subUsersValidationES from "../../locales/es/subUsersValidation";
import subUsersValidationFR from "../../locales/fr/subUsersValidation";
import subUsersValidationIT from "../../locales/it/subUsersValidation";
import subUsersValidationHR from "../../locales/hr/subUsersValidation";
import subUsersValidationNL from "../../locales/nl/subUsersValidation";
import subUsersValidationPT from "../../locales/pt/subUsersValidation";

import axios from "axios";
import { getCookie } from "../../jwt/_helpers/cookie";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const usernameRegex = /^[A-Za-z0-9]*$/;
const passwordRegex = /^(?=.*?[A-Z])(?=.*?[#?!@$%^&*-]).{10,}$/;

export const validationMessages = {
  en: subUsersValidationEN.add,
  de: subUsersValidationDE.add,
  es: subUsersValidationES.add,
  fr: subUsersValidationFR.add,
  it: subUsersValidationIT.add,
  hr: subUsersValidationHR.add,
  nl: subUsersValidationNL.add,
  pt: subUsersValidationPT.add,
};


const createValidationOptions = (lang) => {
  return {
    fields: {
      first_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'first_name', 'required', lang)
          }
        }
      },
      last_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'last_name', 'required', lang)
          }
        }
      },
      email: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'email', 'required', lang)
          },
          emailAddress:
          {
            message: getValidationMessage(validationMessages, 'email', 'invalid', lang)
          },
          promise: {
            message: getValidationMessage(validationMessages, 'email', 'unique', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
  
                if(input.value !== "") {
                  const token = getCookie("token");
  
                  const requestBody = {
                    email: input.value,
                  };
  
                  axios({
                    method: "POST",
                    mode: 'cors',
                    url: `${API_URL}sub-users/validate-email/`,
                    data: requestBody,
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "x-api-key": X_API_KEY,
                    }
                  }).then(function(response) {
                    if (response.status === 200) {
                      const valid = response.data.valid;
                      const message = response.data.status;
                      valid? resolve({ valid: true, message: message }) : resolve({ valid: false, message: message });
                    } else {
                      reject({valid: false, message: getValidationMessage(validationMessages, 'email', 'invalid', lang)});
                    }
                  });
                }
              
              });
           }
          },
        }
      },
      username: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'username', 'required', lang)
          },
          stringCase:{
            case: 'lower',
            message: getValidationMessage(validationMessages, 'username', 'stringCaseLower', lang),
          },
          regexp: {
            regexp: usernameRegex,
            message: getValidationMessage(validationMessages, 'username', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessages, 'username', 'unique', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
  
                if(input.value !== "") {
  
                  const token = getCookie("token");
                  
                  const requestBody = {
                    username: input.value,
                  };
  
                  axios({
                    method: "POST",
                    mode: 'cors',
                    url: `${API_URL}sub-users/validate-username/`,
                    data: requestBody,
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "x-api-key": X_API_KEY,
                    }
                  }).then(function(response) {
                    if (response.status === 200) {
                      const valid = response.data.valid;
                      const message = response.data.status;
                      valid? resolve({ valid: true, message: message }) : resolve({ valid: false, message: message });
                    } else {
                      reject({valid: false, message: getValidationMessage(validationMessages, 'username', 'invalid', lang)});
                    }
                  });
                }
              
              });
           }
          },
        }
      },
      password: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'password', 'required', lang)
          },
          regexp: {
            regexp: passwordRegex,
            message: getValidationMessage(validationMessages, 'password', 'regexp', lang),
          },
        }
      },
      confirmPassword: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'confirmPassword', 'required', lang)
          },
          identical: {
            compare: function() {
              return document
                .getElementById("addNewSubUser")
                .querySelector('[name="password"]').value;
            },
            message: getValidationMessage(validationMessages, 'confirmPassword', 'identical', lang),
          },
        },
      },
      contract_expiry: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'contract_expiry', 'required', lang)
          }
        }
      },
      sub_user_deal: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'sub_user_deal', 'required', lang)
          },
          between: {
            min: 0,
            max: 100,
            message: getValidationMessage(validationMessages, 'sub_user_deal', 'between', lang)
          }
        }
      },
      street_and_number: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'street_and_number', 'required', lang)
          }
        }
      },
      postal_code: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'postal_code', 'required', lang)
          }
        }
      },
      city: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'city', 'required', lang)
          }
        }
      },
      country: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'country', 'required', lang)
          }
        }
      },
      phone: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'phone', 'required', lang)
          }
        }
      },
    },
    plugins: {
      trigger: new Trigger(),
      bootstrap: new Bootstrap(),
      submitButton: new SubmitButton(),
      declarative: new Declarative({
        html5Input: true
      })
    }
  };
};

export { createValidationOptions };